/** One place asks the question, so the canvases and the page tweens can never
 *  disagree about whether this visitor wants motion. */
export const prefersReducedMotion = () =>
  typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
